export class SetBreadcrumbDetail {
  static readonly type = '[SETTINGS] Set breadcrumb detail';
  constructor(public readonly detail: String) {}
}

export class SetTitle {
  static readonly type = '[SETTINGS] Set title page';
  constructor(public readonly title: String) {}
}
